/**
 * This function does nothing. It's useful for placeholders and finding
 * opportunities for refactoring and completing incomplete features in the
 * future. If you're using this as a placeholder, please leave a JIRA ticket
 * so the effort is not lost!
 */
export const doNothing: (...args: any[]) => any = () => {};
